import { nativeService } from './service';
import { AppOperations } from './app-operations';
import { setTimeoutAsync } from '../utils/timeout';
import { clientContext } from '../client/context';
import { demoReceiptUtil } from '../iap/demo-receipt-util';
import { clientApi } from '../client/api';

const updateReceipt = (receipt:string) => {
  if (receipt !== nativeService.context.receipt) {
    nativeService.context.receipt = receipt;
  }
};

class NativeStoreKitService {
  productIds = {
    Monthly: 'Monthly',
    Annual: 'Annual',
    all: ['Monthly', 'Annual'],
  };
  async getReceipt(args: AppOperations['get-receipt']['request']): Promise<AppOperations['get-receipt']['response']> {
    const res = await nativeService.run('get-receipt', args);
    updateReceipt(res.receipt);
    return res;
  }

  async refreshReceipt(args: AppOperations['refresh-receipt']['request']): Promise<AppOperations['refresh-receipt']['response']> {
    clientApi.hit('refreshReceipt');
    const res = await nativeService.run('refresh-receipt', args);
    updateReceipt(res.receipt);
    return res;
  }

  async purchase(args: AppOperations['purchase']['request']): Promise<AppOperations['purchase']['response']> {
    clientApi.hit('purchase', { productId: args.productId });
    const res = await nativeService.run('purchase', args);
    updateReceipt(res.receipt);
    return res;
  }

  getProducts(args: AppOperations['get-products']['request']): Promise<AppOperations['get-products']['response']> {
    return nativeService.run('get-products', args);
  }

  async goat (expiresOnMs?: number): Promise<void> {
    const demo = demoReceiptUtil.generate({
      status: {
        statusMs: Date.now(),
        expiresOnMs: expiresOnMs || (Date.now() + (1000 * 60*60*24*30)),
        ok: true,
      },
    });
    updateReceipt(demo);
    clientContext.settings.registrationTime = clientContext.settings.registrationTime || Date.now();
  }
}

class DemoStoreKitService extends NativeStoreKitService {
  receipt: string = demoReceiptUtil.generate({ status: { statusMs: Date.now(), expiresOnMs: Date.now() + (1000 * 60*60*24*30), ok: true }});

  async getReceipt(args: AppOperations['get-receipt']['request']): Promise<AppOperations['get-receipt']['response']> {
    await setTimeoutAsync(100);
    return { receipt: this.receipt };
  }

  async refreshReceipt(args: AppOperations['refresh-receipt']['request']): Promise<AppOperations['refresh-receipt']['response']> {
    await setTimeoutAsync(1000);
    return { receipt: this.receipt };
  }

  async purchase(args: AppOperations['purchase']['request']): Promise<AppOperations['purchase']['response']> {
    await setTimeoutAsync(1000);
    const msg = `Buy ${args.productId}?`;
    if (confirm(msg)) {
      await setTimeoutAsync(1000);
      this.receipt = demoReceiptUtil.generate({
        status: {
          statusMs: Date.now(),
          expiresOnMs: Date.now() + (1000 * 60*60*24*30),
          ok: true,
        },
      });
      updateReceipt(this.receipt);
      return { receipt: this.receipt, success: true };
    }else{
      await setTimeoutAsync(100);
      return { receipt: this.receipt, success: false };
    }
  }

  async getProducts(args: AppOperations['get-products']['request']): Promise<AppOperations['get-products']['response']> {
    await setTimeoutAsync(3000);
    return {
      products: [
        {
          title: 'Monthly',
          price: '0.99',
          currency: 'USD',
          currencySymbol: '$',
          description: 'Access all premium features on a monthly basis.',
          identifier: 'Monthly',
        },
        {
          title: 'Annual',
          price: '5.99',
          currency: 'USD',
          currencySymbol: '$',
          description: 'Access all premium features for a year.',
          identifier: 'Annual',
        },
      ]
    };
  }
}


export const nativeStoreKitService = (clientContext.isBrowser || clientContext.demoMode) ? new DemoStoreKitService() : new NativeStoreKitService();
